// src/maintenance/components/FailedView.js
import React from 'react';
import { useRecordContext } from 'react-admin';
import { Card, CardContent, Typography, Alert } from '@mui/material';

const FailedView = () => {
  const record = useRecordContext();
  
  return (
    <Card>
      <CardContent>
        <Alert severity="error">
          <Typography variant="h6" gutterBottom>
            Processing Failed
          </Typography>
          <Typography variant="body2">
            {record.error_message || 'An unknown error occurred during processing.'}
          </Typography>
        </Alert>
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Please contact support or try creating a new maintenance job.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FailedView;